export default {
    props: {
        taskType: {
            type: String,
            required: true,
            validator: (value) => {
                return ['allowance', 'expenseRequest'].includes(value);
            },
        },
    },
    computed: {
        taskPermission() {
            switch (this.taskType) {
                case 'allowance':
                    return 'manageAllowances';
                case 'expenseRequest':
                    return 'manageExpenseRequests';
                default:
                    return null;
            }
        },
    },
};
